<div class="ap-margin-bottom-3">{{ 'financial-obligations.private-lease.main-applicant.months' | apContent }}</div>
<ap-input
    id="privateLeaseMainMonths"
    apInputConstraint
    [stripPattern]="stripPattern"
    [helpText]="'financial-obligations.private-lease.months.help-text' | apContent"
    [formControl]="mainApplicantControl"
    [label]="'financial-obligations.private-lease.months.label' | apContent"
    [messages]="errorMessages"
>
</ap-input>

@if (store.hasCoApplicant) {
    <div class="ap-margin-bottom-3">{{ 'financial-obligations.private-lease.co-applicant.months' | apContent }}</div>
    <ap-input
        id="privateLeaseCoMonths"
        apInputConstraint
        [stripPattern]="stripPattern"
        [helpText]="'financial-obligations.private-lease.months.help-text' | apContent"
        [formControl]="coApplicantControl"
        [label]="'financial-obligations.private-lease.months.label' | apContent"
        [messages]="errorMessages"
    ></ap-input>
}

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
